export const ROUTES = {
  home: '/',
  optOut: '/opt-out',
  optIn: '/opt-in',
  optInClose: '/opt-in-close',
  verifyIdentity: '/verify-identity',
  sendCodeSuccess: '/code-sent',
  confirmationSuccess: '/confirmation-success',
  optInSuccess: '/opted-in',
  hostInfo: '/host-info',
  optInRequired: 'opt-in-required',
  stepUp: '/step-up',
  preference: 'preference',
  passwordResetInformation: '/password-reset/information',
  passwordResetCode: '/password-reset/code-entry',
  passwordResetNewPassword: '/password-reset/new-password',
  passwordResetSuccess: '/password-reset/success',
};
